import { SET_UNDERWRITER, RESET_UNDERWRITER } from './actions';
import config from '../../config/index';
import { getUnderwriterInfo } from './helpers'

const initialState = () => {
    const res = getUnderwriterInfo(config.defaultContactUnderWriter);
    return res;
}


export default function (state = initialState(), action) {
    const { type, payload } = action;
    switch (type) {
        case SET_UNDERWRITER:
            return { ...payload };
        case RESET_UNDERWRITER:
            return initialState();
        default:
            return state;
    }
};

